/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CurrentUserDetailOrganizationDetails } from './CurrentUserDetailOrganizationDetails';
import {
    CurrentUserDetailOrganizationDetailsFromJSON,
    CurrentUserDetailOrganizationDetailsFromJSONTyped,
    CurrentUserDetailOrganizationDetailsToJSON,
} from './CurrentUserDetailOrganizationDetails';
import type { CurrentUserDetailOrganizationSettings } from './CurrentUserDetailOrganizationSettings';
import {
    CurrentUserDetailOrganizationSettingsFromJSON,
    CurrentUserDetailOrganizationSettingsFromJSONTyped,
    CurrentUserDetailOrganizationSettingsToJSON,
} from './CurrentUserDetailOrganizationSettings';
import type { UserDetailAppMetadata } from './UserDetailAppMetadata';
import {
    UserDetailAppMetadataFromJSON,
    UserDetailAppMetadataFromJSONTyped,
    UserDetailAppMetadataToJSON,
} from './UserDetailAppMetadata';
import type { UserDetailUserType } from './UserDetailUserType';
import {
    UserDetailUserTypeFromJSON,
    UserDetailUserTypeFromJSONTyped,
    UserDetailUserTypeToJSON,
} from './UserDetailUserType';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface CurrentUserDetail
 */
export interface CurrentUserDetail {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    status: CurrentUserDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    auth_method: CurrentUserDetailAuthMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    dob?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    date_of_hire?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    s3_photo_key?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    s3_photo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    last_sign_in_time?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    emergency_contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    emergency_contact_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDetail
     */
    receive_crm_notifications?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    user_type_id: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    state_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    organization_employment_type_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    login_url_preference?: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    hospital_chat_signature?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDetail
     */
    is_deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    deletedAt?: string;
    /**
     * 
     * @type {UserDetailUserType}
     * @memberof CurrentUserDetail
     */
    user_type?: UserDetailUserType;
    /**
     * 
     * @type {Array<UserFacilityAccess>}
     * @memberof CurrentUserDetail
     */
    user_facility_accesses?: Array<UserFacilityAccess>;
    /**
     * 
     * @type {UserDetailAppMetadata}
     * @memberof CurrentUserDetail
     */
    app_metadata?: UserDetailAppMetadata;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentUserDetail
     */
    enabled_dynamic_permissions: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDetail
     */
    email_hash?: string;
    /**
     * Highest Pylon unread-message count the user has already acknowledged (via close or read). Counts above this are treated as new.
     * @type {number}
     * @memberof CurrentUserDetail
     */
    pylon_unread_baseline?: number;
    /**
     * Facility the user's Screener view defaults to on a fresh session. Mutually exclusive with default_screener_facility_type; both null means the home facility.
     * @type {string}
     * @memberof CurrentUserDetail
     */
    default_screener_facility_id?: string;
    /**
     * Care setting whose all-facilities Screener view the user defaults to on a fresh session. Mutually exclusive with default_screener_facility_id.
     * @type {string}
     * @memberof CurrentUserDetail
     */
    default_screener_facility_type?: string;
    /**
     * 
     * @type {CurrentUserDetailOrganizationSettings}
     * @memberof CurrentUserDetail
     */
    organization_settings: CurrentUserDetailOrganizationSettings;
    /**
     * 
     * @type {CurrentUserDetailOrganizationDetails}
     * @memberof CurrentUserDetail
     */
    organization_details: CurrentUserDetailOrganizationDetails;
}


/**
 * @export
 */
export const CurrentUserDetailStatusEnum = {
    Active: 'active',
    Pending: 'pending',
    Deactivated: 'deactivated'
} as const;
export type CurrentUserDetailStatusEnum = typeof CurrentUserDetailStatusEnum[keyof typeof CurrentUserDetailStatusEnum];

/**
 * @export
 */
export const CurrentUserDetailAuthMethodEnum = {
    Password: 'password',
    Sso: 'sso'
} as const;
export type CurrentUserDetailAuthMethodEnum = typeof CurrentUserDetailAuthMethodEnum[keyof typeof CurrentUserDetailAuthMethodEnum];


/**
 * Check if a given object implements the CurrentUserDetail interface.
 */
export function instanceOfCurrentUserDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "auth_method" in value;
    isInstance = isInstance && "user_type_id" in value;
    isInstance = isInstance && "enabled_dynamic_permissions" in value;
    isInstance = isInstance && "organization_settings" in value;
    isInstance = isInstance && "organization_details" in value;

    return isInstance;
}

export function CurrentUserDetailFromJSON(json: any): CurrentUserDetail {
    return CurrentUserDetailFromJSONTyped(json, false);
}

export function CurrentUserDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'status': json['status'],
        'auth_method': json['auth_method'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'date_of_hire': !exists(json, 'date_of_hire') ? undefined : json['date_of_hire'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        's3_photo_url': !exists(json, 's3_photo_url') ? undefined : json['s3_photo_url'],
        'pin': !exists(json, 'pin') ? undefined : json['pin'],
        'last_sign_in_time': !exists(json, 'last_sign_in_time') ? undefined : json['last_sign_in_time'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'emergency_contact_name': !exists(json, 'emergency_contact_name') ? undefined : json['emergency_contact_name'],
        'emergency_contact_number': !exists(json, 'emergency_contact_number') ? undefined : json['emergency_contact_number'],
        'receive_crm_notifications': !exists(json, 'receive_crm_notifications') ? undefined : json['receive_crm_notifications'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'user_type_id': json['user_type_id'],
        'state_id': !exists(json, 'state_id') ? undefined : json['state_id'],
        'organization_employment_type_id': !exists(json, 'organization_employment_type_id') ? undefined : json['organization_employment_type_id'],
        'login_url_preference': !exists(json, 'login_url_preference') ? undefined : json['login_url_preference'],
        'hospital_chat_signature': !exists(json, 'hospital_chat_signature') ? undefined : json['hospital_chat_signature'],
        'is_deleted': !exists(json, 'is_deleted') ? undefined : json['is_deleted'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : json['deletedAt'],
        'user_type': !exists(json, 'user_type') ? undefined : UserDetailUserTypeFromJSON(json['user_type']),
        'user_facility_accesses': !exists(json, 'user_facility_accesses') ? undefined : ((json['user_facility_accesses'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'app_metadata': !exists(json, 'app_metadata') ? undefined : UserDetailAppMetadataFromJSON(json['app_metadata']),
        'enabled_dynamic_permissions': json['enabled_dynamic_permissions'],
        'email_hash': !exists(json, 'email_hash') ? undefined : json['email_hash'],
        'pylon_unread_baseline': !exists(json, 'pylon_unread_baseline') ? undefined : json['pylon_unread_baseline'],
        'default_screener_facility_id': !exists(json, 'default_screener_facility_id') ? undefined : json['default_screener_facility_id'],
        'default_screener_facility_type': !exists(json, 'default_screener_facility_type') ? undefined : json['default_screener_facility_type'],
        'organization_settings': CurrentUserDetailOrganizationSettingsFromJSON(json['organization_settings']),
        'organization_details': CurrentUserDetailOrganizationDetailsFromJSON(json['organization_details']),
    };
}

export function CurrentUserDetailToJSON(value?: CurrentUserDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'email': value.email,
        'status': value.status,
        'auth_method': value.auth_method,
        'username': value.username,
        'title': value.title,
        'gender': value.gender,
        'phone': value.phone,
        'dob': value.dob,
        'ssn': value.ssn,
        'date_of_hire': value.date_of_hire,
        's3_photo_key': value.s3_photo_key,
        's3_photo_url': value.s3_photo_url,
        'pin': value.pin,
        'last_sign_in_time': value.last_sign_in_time,
        'address': value.address,
        'emergency_contact_name': value.emergency_contact_name,
        'emergency_contact_number': value.emergency_contact_number,
        'receive_crm_notifications': value.receive_crm_notifications,
        'facility_id': value.facility_id,
        'user_type_id': value.user_type_id,
        'state_id': value.state_id,
        'organization_employment_type_id': value.organization_employment_type_id,
        'login_url_preference': value.login_url_preference,
        'hospital_chat_signature': value.hospital_chat_signature,
        'is_deleted': value.is_deleted,
        'deletedAt': value.deletedAt,
        'user_type': UserDetailUserTypeToJSON(value.user_type),
        'user_facility_accesses': value.user_facility_accesses === undefined ? undefined : ((value.user_facility_accesses as Array<any>).map(UserFacilityAccessToJSON)),
        'app_metadata': UserDetailAppMetadataToJSON(value.app_metadata),
        'enabled_dynamic_permissions': value.enabled_dynamic_permissions,
        'email_hash': value.email_hash,
        'pylon_unread_baseline': value.pylon_unread_baseline,
        'default_screener_facility_id': value.default_screener_facility_id,
        'default_screener_facility_type': value.default_screener_facility_type,
        'organization_settings': CurrentUserDetailOrganizationSettingsToJSON(value.organization_settings),
        'organization_details': CurrentUserDetailOrganizationDetailsToJSON(value.organization_details),
    };
}

